import { LAST_VISITED_BRAND_STORAGE_KEY, AUTH_LANGUAGE_STORAGE_KEY, LAST_SHARE_LINK_STORAGE_KEY } from '../constants';

/**
 * Keys that outlive a session. Everything else in localStorage belongs to the signed-in user and
 * must go when the session ends, but these describe the person using this browser rather than the
 * session itself, so they survive logout, session expiry and the next login.
 */
const CROSS_SESSION_KEYS: string[] = [
  AUTH_LANGUAGE_STORAGE_KEY,
  LAST_VISITED_BRAND_STORAGE_KEY,
  LAST_SHARE_LINK_STORAGE_KEY,
];

/**
 * Ends the local session: clears localStorage and sessionStorage, then restores the keys that are
 * meant to outlive it. Every place that used to call `localStorage.clear()` goes through here, so
 * a new cross-session key only has to be declared once instead of being re-preserved at each of
 * the six clear sites (logout, 401 auto-logout, expired-token interceptor, login, switch-user).
 */
export function clearBrowserStorageKeepingPreferences(): void {
  const preserved: Record<string, string> = {};
  CROSS_SESSION_KEYS.forEach((key: string) => {
    const value: string | null = localStorage.getItem(key);
    if (value !== null) {
      preserved[key] = value;
    }
  });

  localStorage.clear();
  sessionStorage.clear();

  Object.entries(preserved).forEach(([key, value]: [string, string]) => localStorage.setItem(key, value));
}
